import { RefObject } from 'react';
/**
 * Calculates the line count in an element
 * @param element The element for which the line counts is needed
 * @returns lines count if element does not exists returns -1
 */
export const getLinesCount = (element: RefObject<Element>) => {
  if (element.current) {
    const elementHeight = element.current?.clientHeight;
    const lineHeight = parseFloat(
      (
        window
          .getComputedStyle(element.current)
          .getPropertyValue('line-height') || ''
      ).replace('px', '')
    );
    if (!isNaN(lineHeight)) return Math.round(elementHeight / lineHeight);
  }
  return -1;
};
